import CallMergeIcon from '@mui/icons-material/CallMerge';
import { Button } from 'react-admin';
import { IfCanAccess } from '@react-admin/ra-rbac';
import { Link } from 'react-router-dom';
import { getSchoolMergePath } from './mergeNavigation';

const SchoolMergeButton = ({
    resource,
    school,
}: {
    resource: string;
    school?: string;
}) =>
    school ? (
        <IfCanAccess action="read" resource="school">
            <IfCanAccess action="read" resource={resource}>
                <IfCanAccess action="read" resource="merge">
                    <Button
                        component={Link}
                        to={getSchoolMergePath(school, resource)}
                        label="merge.workspace.title"
                    >
                        <CallMergeIcon />
                    </Button>
                </IfCanAccess>
            </IfCanAccess>
        </IfCanAccess>
    ) : null;

export default SchoolMergeButton;
